export default __webpack_public_path__ + "static/media/text_bubble_01.18ab6eb5.png";